<div id="chart">
  <apx-chart
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [grid]="chartOptions.grid"
    [legend]="chartOptions.legend"
    [plotOptions]="chartOptions.plotOptions"
    [series]="chartOptions.series"
    [tooltip]="chartOptions.tooltip"
    [xaxis]="chartOptions.xaxis"
  ></apx-chart>
</div>
